(function () {
  'use strict';

  function emitAnalytics(chip) {
    var payload = {
      event: 'hvf_chip_click',
      hvf_id: chip.getAttribute('data-hvf-id'),
      type: chip.getAttribute('data-hvf-type'),
      collection: window.location.pathname,
      resulting_url: chip.getAttribute('href') || chip.getAttribute('data-value') || ''
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function announce(container) {
    var liveRegion = container.querySelector('[data-hvf-live-region]');
    if (!liveRegion) return;
    var countEl = container.querySelector('.t4s-active-filters__count');
    if (countEl && countEl.textContent.trim()) {
      liveRegion.textContent = countEl.textContent.trim();
    }
  }

  function restoreFocus(container, hvfId) {
    if (!hvfId) return;
    var next = container.querySelector('.t4s-hvf-chip[data-hvf-id="' + hvfId + '"]');
    if (next) next.focus();
  }

  document.querySelectorAll('[data-ntajax-container]').forEach(function (container) {
    var pendingHvfId = null;

    container.addEventListener('click', function (e) {
      var chip = e.target.closest('.t4s-hvf-chip');
      if (!chip) return;
      pendingHvfId = chip.getAttribute('data-hvf-id');
      emitAnalytics(chip);
    }, true);

    var observer = new MutationObserver(function () {
      announce(container);
      restoreFocus(container, pendingHvfId);
      pendingHvfId = null;
    });
    observer.observe(container, { childList: true });
  });
})();
